import {
  GETTER_TOAST_STATE,
  ACTION_SHOW_TOAST,
  MUTATE_SHOW_TOAST,
} from './types';

const defaultState = () => ({
  show: false,
  text: '',
  theme: 'primary',
  duration: 3000,
  position: 'bottom',
});

const state = defaultState();

const getters = {
  [GETTER_TOAST_STATE]: (state) => state,
};

const actions = {
  [ACTION_SHOW_TOAST]({commit}, stateProps = {}) {
    commit(MUTATE_SHOW_TOAST, stateProps);
  },
};

const mutations = {
  [MUTATE_SHOW_TOAST](state, stateProps) {
    Object.assign(state, defaultState(), stateProps);
    state.show = true;

    setTimeout(() => {
      const initial = defaultState();
      Object.keys(initial).forEach((key) => {
        state[key] = initial[key];
      });
    }, state.duration);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
